<template>
  <container
    subHeaderTitle="세이프가드·금융사기방지<br /><b>가입하기</b>"
    subHeaderText="서비스 가입 전 이용약관을 반드시 읽어보시고,<br />가입하시는 분의 정보를 정확히 입력하시기 바랍니다."
    subHeaderAlign="center"
  >
    <template v-slot="{showTerms}">
      <section class="form-area mb-180">
        <v-container class="py-0">
          <v-row justify="center">
            <v-col cols="12" md="4" sm="6">
              <v-form v-model="valid" ref="form" onsubmit="return false;">
                <p>이름</p>
                <v-text-field v-model="name" :rules="rules.nameRules" label="이름" solo />
                <p>생년월일</p>
                <v-text-field v-model="birth" :rules="rules.birthRules" label="19990101" mask="########" solo />
                <div class="d-flex align-center">
                  <v-radio-group v-model="genCd" hide-details row class="mt-0">
                    <v-radio label="남" value="M"></v-radio>
                    <v-radio label="여" value="F"></v-radio>
                  </v-radio-group>
                  <v-switch v-model="foreignerChk" label="내국인" hide-details flat class="ml-2 mt-0" />
                </div>
                <div class="check-all">
                  <v-checkbox label="모든 약관 동의" v-model="chk_all" @change="checkAll()" :rules="[(v) => !!v || '약관에 동의해주세요']" />
                </div>
                <v-divider class="mt-2 mb-5" />
                <div class="check-item">
                  <v-checkbox v-model="chk_a1" hide-details @change="checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a1">개인정보 수집/이용 동의(필수)</div>
                      <div class="ml-auto">
                        <button type="button" @click.stop="showTerms({termsCd: '311', prdtNo: 'A002', teleCoCd: '3', isExternalTerm: true, externalTermUrl: 'https://cert.vno.co.kr/app/agree/app_agree_m_lgm.jsp?gubun=01'})">
                          <v-icon>mdi-chevron-right</v-icon>
                        </button>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="check-item">
                  <v-checkbox v-model="chk_a2" hide-details @change="checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a2">서비스 이용약관 동의(필수)</div>
                      <div class="ml-auto">
                        <button type="button" @click.stop="showTerms({termsCd: '314', prdtNo: 'A002', teleCoCd: '3', isExternalTerm: true, externalTermUrl: 'https://cert.vno.co.kr/app/agree/app_agree_m_lgm.jsp?gubun=04'})">
                          <v-icon>mdi-chevron-right</v-icon>
                        </button>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="check-item">
                  <v-checkbox v-model="chk_a3" hide-details @change="checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a3">고유식별정보처리 동의(필수)</div>
                      <div class="ml-auto">
                        <button type="button" @click.stop="showTerms({termsCd: '312', prdtNo: 'A002', teleCoCd: '3', isExternalTerm: true, externalTermUrl: 'https://cert.vno.co.kr/app/agree/app_agree_m_lgm.jsp?gubun=02'})">
                          <v-icon>mdi-chevron-right</v-icon>
                        </button>
                      </div>
                    </template>
                  </v-checkbox>
                </div>
                <div class="check-item">
                  <v-checkbox v-model="chk_a4" hide-details @change="checkBoxCheck()">
                    <template v-slot:label>
                      <div id="a4">통신사 이용약관 동의(필수)</div>
                      <div class="ml-auto">
                        <button type="button" @click.stop="showTerms({termsCd: '313', prdtNo: 'A002', teleCoCd: '3', isExternalTerm: true, externalTermUrl: 'https://cert.vno.co.kr/app/agree/app_agree_m_lgm.jsp?gubun=03'})">
                          <v-icon>mdi-chevron-right</v-icon>
                        </button>
                      </div>
                    </template>
                  </v-checkbox>
                </div>

                <div class="recaptcha-area">
                  <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                  <div class="v-messages theme--light error--text mt-2">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                    </div>
                  </div>
                </div>
                <div>
                  <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                  :data-ga-category="gaEvent.category.support.safeguard.lgIdVerify.name" :data-ga-label="gaEvent.category.support.safeguard.lgIdVerify.label1" :data-ga-action="gaEvent.actions.buttonClick"
                  >본인인증</v-btn>
                </div>
                <div class="text-center mt-3">
                  <v-btn class="back" text rounded @click.stop="goBack"
                  :data-ga-category="gaEvent.category.support.safeguard.lgIdVerify.name" :data-ga-label="gaEvent.category.support.safeguard.lgIdVerify.label2" :data-ga-action="gaEvent.actions.buttonClick"
                  >취소</v-btn>
                </div>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </section>

      <!-- 미성년자 체크  -->
      <v-dialog v-model="adtDialog" persistent max-width="290">
        <v-card>
          <v-card-text class="pt-8 text-center">
            <v-icon x-large class="mb-4">mdi-alert-circle-outline</v-icon>
            <h4>19세 미만은 가입이<br />불가한 부가서비스 입니다.</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.native="adtDialog = false">확인</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- 처리 프로그레스 -->
      <v-dialog v-model="progressDialog" persistent max-width="100">
        <v-card>
          <v-progress-linear color="primary" indeterminate></v-progress-linear>
        </v-card>
      </v-dialog>

    </template>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeguardIdVerify from "@/views/csCenter/PassSafeguardIdVerify.vue";
import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [PassSafeguardIdVerify, GaTracking],
  name: "PassSafeguardIdVerify",
  components: {
    Container
  },
  computed: {
    isLGU() {
      return this.teleCoCd == "3" || this.teleCoCd == "7";
    }
  },
  methods: {
    submit(e) {
      this.gaTracking(e);
      this.progressDialog = true;
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      if (!this.valid) {
        this.progressDialog = false;
        return false;
      }
      if (!this.recaptchaVerify) {
        this.progressDialog = false;
        return false;
      }
      if (!this.adtChek()) {
        // 미성년자 체크
        this.adtDialog = true;
        this.progressDialog = false;
        return false;
      }
      if (this.teleCoCd == "1") {
        this.prdtNo = "A001";
      } else if (this.teleCoCd == "2") {
        this.prdtNo = "A003";
      } else if (this.isLGU) {
        this.prdtNo = "A002";
      }

      // 가입화면에서 받아옴
      const params = {
        type: this.type,
        teleCoCd: this.teleCoCd,
        cellTelNo: this.cellTelNo,
        birth: this.birth,
        genCd: this.genCd,
        name: this.name,
        prdtNo: this.prdtNo,
        foreignerChk: this.foreignerChk,
        mvnoYn: this.mvnoYn
      };

      this.$router.push({
        name: "PassSafeGuardIdVerifyCert", // 본인인증번호 입력 화면 idVerifyCert
        params: {
          ...params
        }
      });
    },
    goBack(e){
      this.gaTracking(e);
      this.$router.push({ name: 'Support' });
    }
  }
};
</script>
